export function formatDesc(desc, num) {
    if (desc.length >= 200) {
        var newDesc = desc.slice(0, 200) + `...`;
    } else {
        var newDesc = desc;
    }
    return newDesc;
}